
import { onUnmounted } from 'vue';
import {useAppStore} from '../store'

export function useEvent<T = void>(name: string, callback?: (payload: T) => void) {
  const app = useAppStore()
  if(callback){
    app.events.on(name, callback)
    onUnmounted(() => app.events.off(name, callback))
  }
  return (payload: T) => app.events.emit(name, payload)
}